import { apiClient } from '../utils/api';

export async function updateCustomField(data) {
  return await apiClient.PUT(`api/templates/${data.id}/response`, {
    lead_text_id: data.lead_text_id,
    custom_fields: data.custom_fields
  });
}

/**
 * Submit consult-request custom field answers (no template).
 * Used when the questionnaire is from consult_request_fields (widget channel).
 * @param {string} leadTextId
 * @param {Record<string, *>} customFields - field id -> value
 * @param {Record<string, string>} [fieldLabels] - field id -> label (so dashboard shows question text)
 */
export async function updateConsultRequestFields(leadTextId, customFields, fieldLabels = {}) {
  const body = { custom_fields: customFields };
  if (Object.keys(fieldLabels).length > 0) {
    body.field_labels = fieldLabels;
  }
  return await apiClient.PUT(
    `api/widget/leads/${leadTextId}/consult-request-fields`,
    body
  );
}

/**
 * Submit appointment channel qualification form answers (form stored on channel, no Template).
 * Used when qualification_form.id is 'ac-{appointmentChannelId}'.
 * When eventId is provided (event already created), the API also saves form_fields to that event.
 * @param {string} leadTextId
 * @param {number} appointmentChannelId
 * @param {Record<string, *>} customFields - field id -> value
 * @param {Record<string, string>} [fieldLabels] - field id -> label
 * @param {string|null} [eventId] - if the event was already created, pass its id so form_fields are saved on the event
 */
export async function updateQualificationResponses(leadTextId, appointmentChannelId, customFields, fieldLabels = {}, eventId = null) {
  const body = { appointment_channel_id: appointmentChannelId, custom_fields: customFields };
  if (Object.keys(fieldLabels).length > 0) {
    body.field_labels = fieldLabels;
  }
  if (eventId) {
    body.event_id = eventId;
  }
  return await apiClient.PUT(
    `api/widget/leads/${leadTextId}/qualification-responses`,
    body
  );
}
